import { Injectable } from '@angular/core';
import { CommonHttpService } from '../../../shared/services/http.service';
import { ClientModel } from '../../../shared/models/client.model';
import { Subject } from 'rxjs/Subject';
import { Response } from '@angular/http';

@Injectable()
export class CardsCreator {
    private client: ClientModel;
    private createdSource: Subject<null> = new Subject();
    private failedSource: Subject<null> = new Subject();

    public created$ = this.createdSource.asObservable();
    public failed$ = this.failedSource.asObservable();

    constructor(
        protected http: CommonHttpService
    ) {}

    /**
     * Call create card api endpoint.
     **/
    public create(data: any) {
        return this.http
            .useAuth()
            .post(`account/clients/${this.client.id}/cards`, data)
            .subscribe((response: Response) => {
                this.createdSource.next(response.json().data);
            }, (response: Response) => {
                this.failedSource.next(response.json().error);
            });
    }

    /**
     * client property setter.
     **/
    public setClient(client: ClientModel) {
        this.client = client;

        return this;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/account/services/cards/creator.ts